import VueCompositionApi from "@vue/composition-api";
import Vue from "vue";

Vue.use(VueCompositionApi);

export function useRoles() {
  const isAdmin = function () {
    return localStorage.getItem("roles") == "ROLE_ADMIN";
  };

  const isGrantedUser = function () {
    return (
      localStorage.getItem("roles") == "ROLE_USER" ||
      localStorage.getItem("roles") == "ROLE_ADMIN"
    );
  };

  const isGuest = function () {
    return localStorage.getItem("roles") == "ROLE_GUEST";
  };

  return {
    isAdmin,
    isGrantedUser,
    isGuest,
  };
}
